import injectTapEventPlugin from 'react-tap-event-plugin';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import Perf from 'react-addons-perf';

import imm from 'immutable';
import diff from 'immutablediff';
import patch from 'immutablepatch';

import Router from './components/Router';
import * as reducers from './reducers';

injectTapEventPlugin();

const logger = {
  info(...args) {
    console.log(...args);
  },
  warn(...args) {
    console.warn(...args);
  },
  error(...args) {
    console.error(...args);
  }
};

window.log = logger;
global.log = logger;

window.onerror = (message, url, line) => {
  log.error(message, url, line);
};

let init_action_queue = [];

global.store = {
  dispatch(...args) {
    console.log('...');
    init_action_queue.push(args);
  }
};

const reducer = (state = imm.Map(), action) => {
  Object.entries(reducers).forEach(([name, impl]) => {
    let current = state.get(name, null);
    if (current === null || action.type === 'RESET') {
      current = imm.fromJS(impl.CONSTRUCT());
    }
    else if (impl[action.type]) {
      current = impl[action.type](current, action.data, state);
    }
    state = state.set(name, current);
  });
  return state;
};

const store = (window.devToolsExtension ? window.devToolsExtension({actionsBlacklist: ['HIDE_TOOLTIP']})(createStore) : createStore)(reducer);

global.store = store;
global.dispatch = (type, data) => store.dispatch({type, data});

for (const action of init_action_queue) {
  console.log(action);
  store.dispatch(action);
}

window.onresize = (...args) => {
  dispatch('RESIZE_WINDOW', {width: window.innerWidth, height: window.innerHeight});
};

global.Perf = Perf;
//Perf.start();

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router />
    </Provider>,
    document.getElementById('root')
  );
};

const reset = () => {
  dispatch('RESET');
};

render();

export {
  render,
  reset
};
